import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, markRaw, ref } from 'vue';
import { useRoute } from 'vue-router';

import FolderTopMatter from './FolderTopMatter.vue';
import ClusterTopMatter from './ClusterTopMatter.vue';
import FaceTopMatter from './FaceTopMatter.vue';
import AlbumTopMatter from './AlbumTopMatter.vue';
import PlacesTopMatter from './PlacesTopMatter.vue';

import initstate from '@services/init-state';
import { routes } from '@services/router';
import * as utils from '@services/utils/common';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TopMatter',
},
  __name: 'TopMatter',
  setup(__props) {



const route = useRoute();

const dynamicVisible = ref(true);

utils.useBus('memories.recycler.scroll', onRecyclerScroll);

const currentmatter = computed(() => {
  switch (route.name) {
    case routes.Folders.name:
      return markRaw(FolderTopMatter);
    case routes.FolderShare.name:
      return initstate.shareType === 'folder' ? markRaw(FolderTopMatter) : null;
    case routes.AlbumsList.name:
    case routes.Albums.name:
      return markRaw(AlbumTopMatter);
    case routes.PlacesList.name:
    case routes.Places.name:
      return markRaw(PlacesTopMatter);
    case routes.TagsList.name:
    case routes.Tags.name:
      return markRaw(ClusterTopMatter);
    case routes.RecognizeList.name:
    case routes.Recognize.name:
    case routes.FaceRecognitionList.name:
    case routes.FaceRecognition.name:
      return markRaw(FaceTopMatter);
    default:
      return null;
  }
});

function onRecyclerScroll({ dynTopMatterVisible }: utils.BusEvent['memories.recycler.scroll']) {
  dynamicVisible.value = dynTopMatterVisible;
}

return (_ctx: any,_cache: any) => {
  return (currentmatter.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["top-matter-container timeline-scroller-gap", {
      'dynamic-visible': dynamicVisible.value,
    }])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(currentmatter.value)))
      ], 2))
    : _createCommentVNode("", true)
}
}

})